/**
 * Copyright (c) 2026 Zoldier & LCN Softwares All rights reserved.
 *
 * This software is the confidential and proprietary information of Zoldier & LCN Software.
 * You shall not disclose such confidential information and shall use it only
 * in accordance with the terms of the license agreement you entered into with
 * Zoldier & LCN Software.
 */

import type { ReactElement } from 'react';
import { MetaTags } from './components/seo';
import { LandingPage } from './modules/landing';

/**
 * Root component for ZIA Platforms Web (marketing landing).
 *
 * Renders the locale-aware `MetaTags` component alongside the public
 * `LandingPage`. This is a pure static marketing shell — no routing, no
 * authentication, no client state. Every admin CTA on the page performs
 * a hard navigation to the admin application via plain `<a>` tags.
 *
 * @returns The application shell JSX containing SEO meta tags and the landing page.
 * @since 1.0.1
 * @version 1.0.0
 * @author Eng. Letzer Cartagena Negrón
 */
export function App(): ReactElement {
  return (
    <>
      <MetaTags />
      <LandingPage />
    </>
  );
}
